import { createContext, useContext, useMemo, useState } from 'react';

// Lets any page open the phone market picker that lives in the Header.
const MarketPickerContext = createContext({ open: false, setOpen: () => {} });

export function MarketPickerProvider({ children }) {
  const [open, setOpen] = useState(false);
  const value = useMemo(() => ({ open, setOpen }), [open]);
  return <MarketPickerContext.Provider value={value}>{children}</MarketPickerContext.Provider>;
}

export const useMarketPicker = () => useContext(MarketPickerContext);
